module.exports = ".last-nav {\n  background: #178acc; }\n"